import { AxiosError } from 'axios';
import { Notification } from 'components/UI';
import { HTTP_STATUS } from 'constants/httpStatus';

interface ValidationErrorSource {
  base?: string;
  error?: string;
}

interface ValidationError {
  errors: {
    source: ValidationErrorSource;
    status: number;
    title: string;
  };
}

const showDefaultError = () => Notification.Error('Cant download file :(');

const getValidationErrorMessage = (payload: ValidationError): string | undefined => {
  const source = payload?.errors?.source;

  if (typeof source?.base === 'string' && source.base.trim()) {
    return source.base;
  }

  if (typeof source?.error === 'string' && source.error.trim()) {
    return source.error;
  }

  return undefined;
};

export const handleDownloadError = async (e: AxiosError<Blob, Blob>) => {
  if (e?.response != null && e.response.status === HTTP_STATUS.UNPROCESSABLE_ENTITY) {
    try {
      const rawResponse = await e.response.data.text();
      const parsedResponse = JSON.parse(rawResponse) as ValidationError;
      const message = getValidationErrorMessage(parsedResponse);

      if (message) {
        Notification.Error(message);

        return;
      }

      showDefaultError();
    } catch {
      showDefaultError();
    }

    return;
  }

  showDefaultError();
};
